<template>
<v-card
    style="margin-bottom: 15px;"
    v-if="value != null"
>
    <v-card-title class="headline">{{value.customer_name}}</v-card-title>
    <v-card-text>

        <m-named-pair 
            text="Organization"
            :value="value.organization_label + ' ('+value.organization_id+')'"
        />

        <m-named-pair 
            text="Inbox"
            :value="value.inbox_internal_label + ' ('+value.inbox_id+')'"
        />

        <m-named-pair 
            text="Emailed To"
            :value="value.active_to"
        />

        <m-named-pair 
            text="Parser"
            :value="value.parser"
        />

        <m-named-pair 
            text="Contact Request Id"
            :value="value.contact_request_id"
        /> 

         <m-named-pair 
            text="Customer Name"
            :value="value.customer_name"
        />

        <m-named-pair 
            text="Customer Endpoint"
            :value="value.customer_endpoint"
        />

        <m-named-pair 
            text="Contacted By"
            :value="value.contacted_by_employee_label"
        />

        <m-named-pair 
            text="Notes"
            :value="value.notes"
        />
  
 
    </v-card-text>
</v-card>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return {}; }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>